"use client";

import React from "react";
import { Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const teamMembers = [{
  name: "Lovise Jiles",
  position: "President",
  image: "https://solid-silkworm.10web.cloud/wp-content/uploads/2026/04/unnamed.jpg?v=8xt44ul54o6",
  linkedin: "#"
}, {
  name: "Jamelia Hand",
  position: "Executive Director",
  image: "https://solid-silkworm.10web.cloud/wp-content/uploads/2026/04/675275927_10238451889269321_5081637981156571559_n-2.jpg?v=6amjjden8lp",
  linkedin: "#"
}, {
  name: "Cheryl Jiles",
  position: "Vice President",
  image: "https://solid-silkworm.10web.cloud/wp-content/uploads/2026/04/IMG-2035-1.jpg?v=vsgyv584j1i",
  linkedin: "#"
}];
export default function ArchitectsOfLearning() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222947" id="our-leadership" className="bg-background text-foreground py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-6 md:px-12">
        <div ref={headerRef} className={`max-w-2xl mb-16 transition-all duration-1000 ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-4xl md:text-5xl font-bold tracking-tight text-primary mb-6">
            Our Leadership
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            Meet the dedicated hearts and minds guiding The Trust Foundation. Our team is committed to restoring dignity and creating pathways to success for every individual we serve.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {teamMembers.map((member, i) => <TeamMemberCard key={member.name} member={member} index={i} />)}
        </div>
      </div>
    </section>;
}
function TeamMemberCard({
  member,
  index
}: {
  member: typeof teamMembers[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <div data-index={index} ref={ref} className={`group relative overflow-hidden rounded-3xl bg-card border border-border shadow-lg transition-all duration-700 delay-[${index * 150}ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
      <div className="aspect-[3/4] w-full overflow-hidden bg-muted">
        <img src={member.image} alt={member.name} className="h-full w-full object-cover transition-all duration-700 grayscale group-hover:grayscale-0 group-hover:scale-105" />
      </div>

      <div className="absolute bottom-4 left-4 right-4 rounded-2xl bg-background/90 backdrop-blur-md border border-border/50 p-5 shadow-xl transition-transform duration-500 group-hover:-translate-y-1">
        <div className="flex items-center justify-between gap-4">
          <div>
            <h3 className="font-default text-xl font-semibold text-foreground">
              {member.name}
            </h3>
            <p className="text-sm text-muted-foreground font-default mt-1">
              {member.position}
            </p>
          </div>
          <Link to={member.linkedin} newTab className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary/20 text-secondary-foreground transition-colors hover:bg-secondary hover:text-secondary-foreground" aria-label={`LinkedIn profile of ${member.name}`}>
            <Linkedin className="size-5" />
          </Link>
        </div>
      </div>
    </div>;
}